// Copyright 2017 Sorama B.V.

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { MeasurementHealthIssue, MeasurementHealthIssueType } from "datatypes/SoramaLocalApi";
import { NotSupportedError } from "errors/NotSupportedError";

export class MeasurementIssueToDescriptionValueConverter implements IParameterizedValueConverter<
    string,
    MeasurementHealthIssue[],
    boolean
> {
    public toView(issues: MeasurementHealthIssue[], consise: boolean): string {
        if (!issues || issues.length === 0) return "";

        if (issues.length === 1) {
            if (consise) {
                return this.issueTypeToString(issues[0].type);
            } else {
                return "Live streaming might not behave as expected";
            }
        }

        if (issues.length > 1) {
            if (consise) {
                return "Live streaming might not behave as expected";
            } else {
                return (
                    "A number of issues are causing poor performance:\n" +
                    issues.map((x) => "- " + this.issueTypeToString(x.type)).join("\n")
                );
            }
        }
    }

    public fromView(val: string, consise: boolean): MeasurementHealthIssue[] {
        // Not supported
        throw new NotSupportedError("fromView is not supported");
    }

    private issueTypeToString(issueType: MeasurementHealthIssueType): string {
        if (issueType === MeasurementHealthIssueType.InsufficientThroughput) {
            return "Connection to sound camera is too slow";
        }

        if (issueType === MeasurementHealthIssueType.HighCPULoad) {
            return "High CPU load";
        }

        if (issueType === MeasurementHealthIssueType.LowOnMemory) {
            return "Low on memory";
        }
    }
}
